<template>
  <div class="row">
    <div class="col-12 col-lg-3">
      <upload-user-photo :data="data_user" :is_allow_edit="is_allow_edit" @on-add-picture="on_add_picture"/>
      <status :data="data_user" v-show="this.$route.query.id != null && !is_allow_edit"/>
    </div>
    <div class="col-12 col-lg-9">
      <general-info-agent :data="data_user" :is_allow_edit="is_allow_edit"/>
    </div>
    <div class="form-group col-12 text-right">
      <button type="button" class="btn btn-danger" v-show="is_allow_edit" @click="toggle_edit_user">Cancel</button>
      <button type="button" class="btn btn-primary" v-show="is_allow_edit" data-toggle="modal" data-target="#preloader_modal" @click="save">Save</button>

      <button type="button" class="btn btn-primary" v-show="!is_allow_edit" @click="toggle_edit_user">Edit</button>
    </div>
  </div>
</template>

<script>
import {MDCChipSet} from '@material/chips'

import upload_user_photo from '@/pages/user/agent_component/upload_photo'
import general_info_agent from '@/pages/user/agent_component/general_info'
import status from '@/pages/user/agent_component/status'

export default {
  components:{
    'upload-user-photo': upload_user_photo,
    'general-info-agent': general_info_agent,
    'status': status,
  },
  props: {
    data: {
      type: Object,
    },
    is_edited: {
      type: Boolean,
    }
  },
  watch: {
    data: {
      immediate: true,
      async handler(new_val,old_val){
        this.data_user = JSON.parse(JSON.stringify(this.data))
      },
    },
    is_edited(val){
      if(val)
        this.is_allow_edit = !this.is_allow_edit
    }
  },
  data(){
    return{
      data_user: JSON.parse(JSON.stringify(this.data)),
      is_allow_edit: this.$route.query.id != null ? false : true,
    }
  },
  mounted(){
  },
  methods:{
    toggle_edit_user(){
      if(this.$route.query.id != null){
        this.is_allow_edit = !this.is_allow_edit
        this.data_user = this.data
      }
      else
        location.href = "/user"
    },
    on_add_picture(picture){
      
      var data_user = JSON.parse(JSON.stringify(this.data_user))
      data_user.picture = URL.createObjectURL(picture)
      this.data_user = Object.assign({},this.data_user,data_user)
      this.data_user.is_change_picture = true
      console.log(this.data_user)
    },
    save(){

      this.$emit('on-save',this.data_user)
    }
  }
}
</script>

<style>
  .mdc-chip-set--filter .mdc-chip.mdc-chip--selected, .mdc-chip-set--filter .mdc-chip.mdc-chip--selected:hover{
    background-color: #1266f1;
    color: white;
  }
  .mdc-chip-set--filter .mdc-chip.mdc-chip--selected .mdc-chip__ripple::before, .mdc-chip-set--filter .mdc-chip.mdc-chip--selected .mdc-chip__ripple::after{
    background-color: white;
  }
</style>
